import { getRuntimeValue } from "./runtime";

export const BRAND_NAME = getRuntimeValue("VUE_APP_BRAND_NAME", "BRAND_NAME") || process.env.VUE_APP_BRAND_NAME || "Ropilinkhot";
export const BRAND_COPYRIGHT = `© 2023 ${BRAND_NAME}. All rights reserved.`;
